import React from 'react';
import { BankSearchPool } from '../../../../utils/types/candi_bank_types';

export interface CoverageBannerProps {
  pool: BankSearchPool | null;
  skillMatchesStale: boolean;
}

export const CoverageBanner: React.FC<CoverageBannerProps> = ({ pool, skillMatchesStale }) => {
  if (!pool) return null;

  const noMandatory = !pool.activeComponents?.includes('mandatory');

  return (
    <div className='flex flex-wrap items-center justify-between gap-2 bg-white/80 backdrop-blur-xs border border-slate-200/80 rounded-xl px-3.5 py-2 shadow-2xs text-xs'>
      {noMandatory ? (
        <div className='flex items-center gap-1.5 text-amber-800 font-semibold'>
          <svg className='w-3.5 h-3.5 flex-shrink-0 text-amber-600' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <circle cx='12' cy='12' r='10' />
            <line x1='12' y1='8' x2='12' y2='12' />
            <line x1='12' y1='16' x2='12.01' y2='16' />
          </svg>
          <span>None of the listed skills appear in your pool — ranking by overall profile similarity only.</span>
        </div>
      ) : (
        <div className='flex flex-wrap items-center gap-1.5'>
          <span className='text-[11px] font-bold text-slate-500 uppercase tracking-wider mr-1'>Pool Coverage:</span>
          {pool.coverage && Object.entries(pool.coverage).map(([skill, count]) => (
            <span
              key={skill}
              className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-bold border transition-all ${
                count > 0
                  ? 'text-emerald-700 bg-emerald-50/80 border-emerald-200/80'
                  : 'text-red-700 bg-red-50/80 border-red-200/80'
              }`}
            >
              <span>{skill}</span>
              <span className='opacity-75 font-mono'>({count})</span>
            </span>
          ))}
        </div>
      )}

      {skillMatchesStale && (
        <div className='text-[11px] text-indigo-600 font-bold animate-pulse flex items-center gap-1.5 ml-auto'>
          <span className='w-1.5 h-1.5 rounded-full bg-indigo-500' />
          Pool updated — refining matches…
        </div>
      )}
    </div>
  );
};
